import { Cancel, Close, Save } from "@mui/icons-material";
import {
  CircularProgress,
  Dialog,
  DialogActions,
  DialogTitle
} from "@mui/material";
import { Formik } from "formik";
import { isEmpty } from "lodash";
import { useEffect, useRef, useState } from "react";
import { useSelector } from "react-redux";
import { useNavigate, useParams } from "react-router-dom";
import Api from "../../api2";
import Helper from "../../helpers";
import { commonReducerSelector, userSelector } from "../../redux/selector";
import {
  MyBreadCrumbs,
  MyButton,
  MyForm,
  MyTable,
  MyThaoTac,
  ThongBao,
  scrollToError
} from "../Lib/componentLibrarys";
import { ValidateSchema } from "./validate";
import { FormNhap } from "./form";
import { parseDataSave, propsToInitialState } from "./models";

const RoutesLoHang = [
  {
    path: "",
    main: () => <LoHang />
  },
  {
    path: "add",
    main: () => <HandleLoHang />
  },
  {
    path: "edit/:id",
    main: () => <HandleLoHang />
  },
  {
    path: "detail/:id",
    main: () => <HandleLoHang view={true} />
  }
];
export default RoutesLoHang;

function LoHang() {
  const [dataFormik, setFormik] = useState({
    search: "",
    limit: 10,
    anchor: 0
  });
  const common = useSelector(commonReducerSelector);
  const profile = common?.profile?.data;
  const [rawData, setRawData] = useState({});
  const [Count, setCount] = useState();
  const [data, setData] = useState([]);
  const [open, setOpen] = useState(false);
  const [dataQrBase64, setDataQrBase64] = useState(null);
  const [openDiaLogViewLog, setOpenDiaLogViewLog] = useState(false);
  const formikRef = useRef();
  const printRef = useRef();
  //for table method
  const navigate = useNavigate();

  const parseSearchForm = values => {
    const tuKhoa = values?.search?.length > 0 ? values?.search : "";
    const limit = values?.limit ? values.limit : 10;
    const anchor = values?.anchor ? values.anchor : 0;
    const page = values?.page || "";
    return { tuKhoa, limit, anchor, page };
  };

  useEffect(() => {
    const values = formikRef.current?.values;
    getApi(parseSearchForm(values));
  }, []);
  const getRows = (limit, anchor, page) => {
    const values = formikRef.current?.values;
    getApi(parseSearchForm({ ...values, limit, anchor, page }));
  };

  const getApi = ({ tuKhoa, limit, anchor, page }) => {
    new Api()
      .GetListLoHang({ tuKhoa, limit, anchor })
      .then(res => {
        if (res.code === 200) {
          setData(
            Helper.addSttToTableDataSource(res.data.records, page, limit)
          );
          setRawData(res.data);
        }
        if (res.data?.count) {
          setCount(res.data?.count);
        }
      })
      .catch(err => {});
  };
  const onSubmitSearch = () => {
    const values = formikRef.current?.values;
    getApi(parseSearchForm(values));
  };
  const columns = ({ handleEdit, handleDelete }) => {
    var column = [
      {
        headerName: "STT",
        field: "stt",
        width: "100px",
        suppressSizeToFit: true,
        pinned: "left",
        cellStyle: { justifyContent: "center" },
        headerClass: "ag-grid-header-center"
      },
      {
        headerName: "Tên lô hàng",
        field: "tenLoHang",
        width: "350px"
      },
      {
        headerName: "Ngày xuất bán",
        field: "ngayXuatBan",
        width: "200px",
        cellStyle: { justifyContent: "center" },
        headerClass: "ag-grid-header-center",
        cellRenderer: prams => {
          return (
            <div>{Helper.formatDate(prams?.data?.ngayXuatBan * 1000)}</div>
          );
        }
      },
      {
        headerName: "Hạn sử dụng",
        field: "hanSuDung",
        width: "200px"
      },
      { headerName: "Sản lượng", field: "sanLuong", minWidth: 200, flex: 1 },
      {
        headerName: "Thao tác",
        width: "100px",
        pinned: "right",
        cellStyle: { justifyContent: "center" },
        cellRendererFramework: prams => (
          <MyThaoTac
            prams={prams}
            // handleDelete={handleDelete}
            handleEdit={profile?.cap !== 0 && handleEdit}
            handleShowQr={handleShowQr}
            handleViewLog={handleViewLog}
            handleDetail={handleDetail}
          />
        ),
        headerClass: "ag-grid-header-center"
      }
    ];
    return column;
  };

  const handleEdit = params => {
    if (!params?.id) {
      ThongBao({ status: "warn", message: "ID không tồn tại" });
    }
    navigate(`edit/${params?.id || undefined}`);
  };
  const handleAdd = data => {
    navigate(`add`);
  };
  const handleDelete = params => {
    new Api()
      .DeleteLoHangById({ id: params?.id })
      .then(res => {
        if (res.code === 200) {
          const values = formikRef.current.values;
          getApi(parseSearchForm(values));
          ThongBao({ status: "success", message: "Xóa thành công" });
        }
      })
      .catch(err => {});
  };

  const handleShowQr = params => {
    new Api()
      .GetQrLoHangById({ id: params?.id })
      .then(res => {
        if (res.code === 200) {
          setDataQrBase64(res?.data?.qrImage);
          setOpen(params?.tenLoHang);
        } else {
          ThongBao({ status: "error", message: "Lỗi sinh mã QR" });
        }
      })
      .catch(err => {});
  };

  const handleDetail = (data) => {
    if (!data?.id) {
      ThongBao({ status: "warn", message: "ID không tồn tại" });
      return;
    }
    navigate(`detail/${data?.id || undefined}`);
  }

  const handlePrint = () => {
    const content = printRef.current.innerHTML;
    const printWindow = window.open("", "", "");
    printWindow.document.open();
    printWindow.document.write(`
      <html>
        <head>
          <title>In QR Code</title>
        </head>
        <body onload="window.print(); window.close();">
          ${content}
        </body>
      </html>
    `);
    printWindow.document.close();
  };

  // Dialog for view log
  const [dataLog, setDataLog] = useState([]);

  const handleViewLog = (idlohang) => {
    new Api()
      .GetLogLoHangs({ idlohang })
      .then((res) => {
        if (res.code === 200 && !isEmpty(res.data)) {
          setDataLog(res.data);
          setOpenDiaLogViewLog(true);
        } else {
          ThongBao({ status: 'error', message: 'Không có dữ liệu log' });
        }
      });
  };

  return (
    <div className="divMain">
      <MyBreadCrumbs title={[{ name: "Vận hành" }, { name: "Lô hàng" }]} />
      <MyForm
        formikRef={formikRef}
        showSearch={true}
        dataFormik={dataFormik}
        handleAdd={handleAdd}
        editable={true}
        onSubmitAPI={onSubmitSearch}
        marginBottom={"15px"}
        cannotCreate={profile?.cap === 0}
      />
      <MyTable
        autofit={true}
        columns={columns({
          editable: true,
          handleEdit: handleEdit,
          handleDelete: handleDelete
        })}
        data={data}
        pagination={{
          rawData: rawData,
          setData: setData,
          getRows: getRows,
          Count: Count
        }}
      />
      <Dialog
        open={open}
        onClose={() => setOpen(false)}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <div ref={printRef}>
          <div
            style={{
              textAlign: "center",
              fontSize: 25,
              fontWeight: 800,
              margin: "10px 0px 6px 0px"
            }}
          >
            QR CODE
          </div>
          <div
            style={{
              textAlign: "center",
              fontSize: 18,
              fontWeight: 600,
              margin: "0px 6px 0px 6px"
            }}
          >
            Tên lô hàng: {open}
          </div>
          <div
            style={{ width: "100%", display: "flex", justifyContent: "center" }}
          >
            <img
              style={{ width: 300, height: 300 }}
              src={`data:image/png;base64,${dataQrBase64}`}
              alt="QR Code"
            />
          </div>
        </div>
        <DialogActions
          className="capPhep-listInput-dialog-content"
          style={{ display: "flex", justifyContent: "center" }}
        >
          <MyButton
            onClick={() => setOpen(false)}
            txt="Hủy bỏ"
            color="rgb(124, 124, 124)"
            className="capPhep-listInput-dialog-buttonClose"
            icon={<Close />}
          />
          <MyButton
            // onClick={() => {
            //   // arrayHelpers.remove(alert);
            //   // setAlert(false);
            // }}
            onClick={handlePrint}
            txt="In QR-Code"
            className="capPhep-listInput-dialog-buttonCheck"
            // icon={<Check />}
          />
        </DialogActions>
      </Dialog>

      {/* Dialog xem log */}
      <Dialog
        open={openDiaLogViewLog}
        onClose={() => setOpenDiaLogViewLog(false)}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
        maxWidth={false}
        PaperProps={{
          sx: {
            width: "65vw",
            minWidth: 600,
            maxWidth: "90vw",
            height: "80vh",
            maxHeight: "90vh",
            display: "flex",
            flexDirection: "column"
          }
        }}
      >
        <DialogTitle
          className="capPhep-listInput-dialog-title"
          style={{
            width: "100%",
            color: "#24408A",
            fontWeight: 600
          }}
        >
          LOGS LÔ HÀNG
        </DialogTitle>
        <div
          style={{
            marginLeft: 20,
            marginRight: 20,
            paddingRight: 16,
            flex: 1,
            overflowY: "auto",
            minWidth: 350
          }}
        >
          {Array.isArray(dataLog) && dataLog.length > 0 ? (
            dataLog.map((log, idx) => {
              // Lấy tất cả key của dữ liệu cũ và mới, loại bỏ các trường không cần so sánh
              const excludeFields = ['qrImage', 'hinhAnhDaiDienJson', 'hinhAnhDaiDien', 'hinhAnhJson', 'hinhAnhs'];
              const oldData = log.duLieuCu || {};
              const newData = log.duLieuMoi || {};
              const allKeys = Array.from(new Set([...Object.keys(oldData), ...Object.keys(newData)])).filter(key => !excludeFields.includes(key));
              return (
                <div
                  key={idx}
                  style={{
                    border: "1px solid #24408A",
                    borderRadius: 8,
                    marginBottom: 12,
                    padding: 20,
                    background: "#deefffa6"
                  }}
                >
                  <div
                    style={{
                      fontWeight: 600,
                      color: "#40A7DE",
                      marginBottom: 4
                    }}
                  >
                    Lần cập nhật thứ {dataLog.length - idx}
                  </div>
                  <div style={{ fontSize: 13, marginBottom: 2 }}>
                    <b>Ngày sửa:</b> {log.ngaySua || "-"}
                  </div>
                  <div style={{ fontSize: 13, marginBottom: 2 }}>
                    <b>Người sửa:</b> {log.nguoiSua || "-"}
                  </div>
                  <div style={{ fontSize: 13, marginBottom: 2, fontWeight: 600 }}>So sánh thay đổi:</div>
                  <div style={{ overflowX: 'auto' }}>
                    <table style={{ borderCollapse: 'collapse', width: '100%', tableLayout: 'fixed', background: '#fff', fontSize: 13 }}>
                      <colgroup>
                        <col style={{ width: '20%' }} />
                        <col style={{ width: '40%' }} />
                        <col style={{ width: '40%' }} />
                      </colgroup>
                      <thead>
                        <tr style={{ background: '#e3f2fd' }}>
                          <th style={{ border: '1px solid #b3c6e0', padding: '6px 10px', wordBreak: 'break-word', whiteSpace: 'pre-line' }}>Trường</th>
                          <th style={{ border: '1px solid #b3c6e0', padding: '6px 10px', wordBreak: 'break-word', whiteSpace: 'pre-line' }}>Giá trị cũ</th>
                          <th style={{ border: '1px solid #b3c6e0', padding: '6px 10px', wordBreak: 'break-word', whiteSpace: 'pre-line' }}>Giá trị mới</th>
                        </tr>
                      </thead>
                      <tbody>
                        {allKeys.map((key) => {
                          const oldValue = oldData[key];
                          const newValue = newData[key];
                          const isChanged = oldValue !== newValue;
                          return (
                            <tr key={key} style={isChanged ? { background: '#fff9c4' } : {}}>
                              <td style={{ border: '1px solid #b3c6e0', padding: '6px 10px', fontWeight: isChanged ? 600 : 400, wordBreak: 'break-word', whiteSpace: 'pre-line' }}>{key}</td>
                              <td style={{ border: '1px solid #b3c6e0', padding: '6px 10px', color: '#888', wordBreak: 'break-word', whiteSpace: 'pre-line' }}>{oldValue === undefined ? '-' : String(oldValue)}</td>
                              <td style={{ border: '1px solid #b3c6e0', padding: '6px 10px', color: isChanged ? '#d84315' : '#222', fontWeight: isChanged ? 600 : 400, wordBreak: 'break-word', whiteSpace: 'pre-line' }}>{newValue === undefined ? '-' : String(newValue)}</td>
                            </tr>
                          );
                        })}
                      </tbody>
                    </table>
                  </div>
                </div>
              );
            })
          ) : (
            <div
              style={{
                color: "#888",
                fontStyle: "italic",
                textAlign: "center",
                margin: 24
              }}
            >
              Không có dữ liệu log
            </div>
          )}
        </div>
        <DialogActions
          className="capPhep-listInput-dialog-content"
          style={{ display: "flex", justifyContent: "center" }}
        >
          <MyButton
            onClick={() => setOpenDiaLogViewLog(false)}
            txt="Hủy bỏ"
            color="rgb(122, 122, 122)"
            className="capPhep-listInput-dialog-buttonClose"
            icon={<Close />}
          />
        </DialogActions>
      </Dialog>
    </div>
  );
}

function HandleLoHang({ view }) {
  const navigate = useNavigate();
  const user = useSelector(userSelector);
  const [isLoading, setIsLoading] = useState(false);
  const { id } = useParams();
  const [data, setData] = useState(null);
  const common = useSelector(commonReducerSelector);
  const profile = common?.profile;
  const dataDanhMuc = common?.danhmucs?.data;
  const [sanPhamList, setSanPhamList] = useState(null);
  const [coSoCheBienList, setCoSoCheBienList] = useState(null);

  const formRef = useRef(null);

  //ref just for use scroll when error validate
  const refI = useRef(null);

  useEffect(() => {
    if (id && !data) {
      setIsLoading(true);
      new Api()
        .GetLoHangById({ id: id })
        .then(data => {
          if (data.code === 200) {
            setData(data?.data);
          }
        })
        .catch(err => {})
        .finally(() => {
          setIsLoading(false);
        });
    }
    if (isEmpty(sanPhamList)) {
      new Api().GetListSanPhamOfLoHang().then(data => {
        if (data.code === 200) {
          setSanPhamList(data?.data);
        }
      });
    }
    if (isEmpty(coSoCheBienList)) {
      new Api().GetListCoSoCheBien().then(data => {
        if (data.code === 200) {
          setCoSoCheBienList(data?.data?.records);
        }
      });
    }
  }, [id]);

  if (isLoading) {
    return (
      <div className="style-loading">
        <CircularProgress />
      </div>
    );
  }

  //set initial data
  const initialState = propsToInitialState(
    data,
    sanPhamList,
    coSoCheBienList
  );

  //List form
  const formNhap = (
    <Formik
      innerRef={f => (formRef.current = f)}
      i
      initialValues={initialState}
      enableReinitialize={true}
      validateOnBlur={false}
      validateOnChange={false}
      validationSchema={ValidateSchema}
    >
      {({ values, errors, handleSubmit, setFieldValue }) => (
        <form onSubmit={handleSubmit}>
          {/* div just for use scroll when error validate */}
          <div ref={refI}></div>
          <FormNhap
            view={view}
            values={values}
            errors={errors}
            setFieldValue={setFieldValue}
            sanPhamList={sanPhamList}
            coSoCheBienList={coSoCheBienList}
          />
        </form>
      )}
    </Formik>
  );

  //handle when submit API
  const handleSave = async () => {
    await formRef.current.validateForm();

    if (!isEmpty(formRef.current.errors)) {
      scrollToError(refI);
      ThongBao({
        status: "warn",
        message: "Yêu cầu nhập đầy đủ các trường có dấu đỏ"
      });
      return;
    }

    new Api()
      .UpsertLoHang({
        token: user.access_token,
        data: parseDataSave(formRef.current.values, profile)
      })
      .then(res => {
        if (!res || res.code !== 200) {
          //TODO
          ThongBao({ status: "error", message: "Đã có lỗi xảy ra" });
          return;
        }
        ThongBao({ status: "success", message: "Thành công" });
        navigate(-1);
      })
      .catch(err => {
        ThongBao({ status: "error", message: "Đã có lỗi xảy ra" });
      })
      .finally(() => {});
  };

  return (
    <>
      <div
        style={{
          display: "flex",
          flexDirection: "column",
          paddingBottom: "0.875rem"
        }}
      >
        <MyBreadCrumbs
          title={[
            { name: "Vận hành" },
            { name: "Lô hàng", link: -1 },
            { name: `${id ? "Cập nhật " : "Thêm mới"}` }
          ]}
        />
        {formNhap}
      </div>
      <div
        style={{
          display: "flex",
          justifyContent: "flex-end",
          marginBottom: 15
        }}
      >
        <MyButton
          onClick={() => navigate(-1)}
          txt="Hủy bỏ"
          color="#888"
          style={{ width: 130, height: 33, marginTop: 5 }}
          icon={<Cancel />}
        />
        <p style={{ width: 5 }}></p>
        {
          !view && (
            <MyButton
              onClick={() => {
                handleSave();
              }}
              txt="Lưu thông tin"
              style={{ width: 130, height: 33, marginTop: 5 }}
              icon={<Save />}
            />
        )}
      </div>
    </>
  );
}
